module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "page1 page"
  }, [_c('ul', {
    staticClass: "pageItme"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/servicePrice'
    }
  }, [_vm._v("\n          服务价格\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/serviceAgreement'
    }
  }, [_vm._v("\n          服务协议\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "page2 page"
  }, [_c('ul', {
    staticClass: "pageItme"
  }, [_c('li', [_vm._v("\n        服务热线\n        "), _c('span', [_c('a', {
    attrs: {
      "href": 'tel:' + (_vm.infoData.companyinfo ? _vm.infoData.companyinfo.telephone : '')
    }
  }, [_vm._v(_vm._s(_vm.infoData.companyinfo ? _vm.infoData.companyinfo.telephone : ''))])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "logoutBut"
  }, [_c('span', {
    staticClass: "But",
    on: {
      "click": function($event) {
        return _vm.BoxLogoutFn("show")
      }
    }
  }, [_vm._v("\n      注销账户\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "modelBox BoxLogout",
    class: {
      'showModelBox': _vm.BoxLogout
    }
  }, [_c('div', {
    staticClass: "Box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modelBoxBottom clear"
  }, [_c('span', {
    staticClass: "ActionBut NoBut",
    on: {
      "click": function($event) {
        return _vm.BoxLogoutFn('on')
      }
    }
  }, [_vm._v("留下")]), _vm._v(" "), _c('span', {
    staticClass: "ActionBut OKBut",
    on: {
      "click": function($event) {
        return _vm.BoxLogoutFn('ok')
      }
    }
  }, [_vm._v("确认")])])]), _vm._v(" "), (_vm.BoxLogout) ? _c('div', {
    staticClass: "modelBoxModel"
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n        当前版本\n        "), _c('span', [_vm._v("V5.1.12.003")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modelBoxContent"
  }, [_c('span', {
    staticClass: "Icon"
  }, [_c('i', {
    staticClass: "iconfont icon-yy03"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("你确定要注销吗？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b65a17","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/settings.vue
// module id = 504
// module chunks = 0